import styled from 'styled-components';

export const InfoDefaultOperator = styled.div`
  .info-icon {
    margin-top: 0.3rem;
  }
`;
